import React, { useEffect, useState, useContext } from "react";
import CurrencyType from "./columnTypes/CurrencyType";

import { useNavigate } from "react-router-dom";
import ListView from "../../../../../../ui library/components/table/TableView";
import DataContext from "../../../../../../../context/DataContext";

const CaseTable = ({
  customBaseDetailPath,
  customBaseDetailSegment,
  cases,
  filters,
  updateFilter,
  referenceForScrolling
}) => {

  const { setSelectedClient } = useContext(DataContext);
  const [filteredCases, setFilteredCases] = useState(cases);
  const navigate = useNavigate();

  useEffect(() => {
    setFilteredCases(cases);
  }, [cases, filters]);

  const columns = [
    {
      key: "client.name",
      label: "Name",
      type: "string",
      onClick: (row) => {
        setSelectedClient(row.id);
        navigate(`${customBaseDetailPath}${row.id}${customBaseDetailSegment}`);
      },
    },
    {
      key: "dateOfAccident",
      label: "DOA",
      type: "date",
      order: true,
      orderingValue: "date_of_accident",
    },
    { key: "status", label: "Medical Status", type: "string" },
    { key: "overallStatus", label: "Case Status", type: "string" },
    { key: "lawFirmName", label: "Law Firm", type: "string" },
    {
      key: "medicalLimits",
      label: "Medical Limits",
      type: "custom",
      customComponent: CurrencyType,
    },
    {
      key: "currentBalanceTotal",
      label: "Verbal Balance",
      type: "custom",
      customComponent: CurrencyType,
    },
    {
      key: "runningTotal",
      label: "Received Bill Charges",
      type: "custom",
      customComponent: CurrencyType,
    },
  ];

  return (
    <ListView
      columns={columns}
      data={filteredCases}
      filters={filters}
      updateFilter={updateFilter}
      displayIndexColumn={true}
      referenceForScrolling={referenceForScrolling}
    />
  );
};

export default CaseTable;
